<script lang="ts">
	import type { HTMLTextareaAttributes } from "svelte/elements";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const { ...rest }: HTMLTextareaAttributes = $props();
</script>

<textarea
	use:updateTextareaHeight
	{...rest}
	class={[
		" font-semibold md:text-[1.125rem]/[1.2] p-2 md:p-7 focus:border-zms-blue [&:user-invalid]:border-red-300 focus:text-zms-optical-black overflow-auto text-[#595959] min-w-0 border resize-none shadow-sm border-[#D7D7D7] rounded-[.25rem] min-h-[12rem] transition-[outline,text,border] duration-300 focus:[&:user-invalid]:border-red-300",
		rest.class,
	]}
></textarea>
